import { BaseTextFieldProps, InputAdornment, MenuItem, Select, TextField, Typography } from '@mui/material'
import React from 'react'
import 'react-international-phone/style.css'
import {
    CountryIso2,
    defaultCountries,
    FlagImage,
    parseCountry,
    ParsedCountry,
    usePhoneInput
} from 'react-international-phone'

export interface MUIPhoneProps extends BaseTextFieldProps {
    value: string;
    onChange: (phone: { phone: string; inputValue: string; country: ParsedCountry }) => void;
    selectedCode: string,
}

export const PhoneInput: React.FC<MUIPhoneProps> = ({ value, onChange, selectedCode, ...restProps }) => {
    const {
        phone,
        handlePhoneValueChange,
        inputRef,
        country,
        setCountry
    } = usePhoneInput({
        defaultCountry: selectedCode,
        disableDialCodePrefill: true,
        value,
        prefix: '',
        disableCountryGuess: true,
        onChange: (data) => {
            onChange(data)
        }
    })

    return (
        <TextField
            fullWidth={true}
            variant="outlined"
            label="Phone number"
            autoFocus={true}
            color="primary"
            placeholder="Phone number"
            value={phone}
            onChange={handlePhoneValueChange}
            type="tel"
            inputRef={inputRef}
            InputProps={{
                startAdornment: (
                    <InputAdornment
                        position="start"
                        style={{ marginRight: '2px', marginLeft: '-8px' }}
                    >
                        <Select
                            MenuProps={{
                                style: {
                                    top: '10px',
                                    left: '-34px'
                                },
                                transformOrigin: {
                                    vertical: 'top',
                                    horizontal: 'left'
                                }
                            }}
                            sx={{
                                width: 'max-content',
                                // Remove default outline (display only on focus)
                                fieldset: {
                                    display: 'none'
                                },
                                // Update default spacing
                                '.MuiSelect-select': {
                                    padding: '8px',
                                    paddingRight: '24px !important'
                                },
                                svg: {
                                    right: 0
                                }
                            }}
                            value={country}
                            onChange={(e) => {
                                const country = e.target.value as ParsedCountry
                                setCountry((e.target.value as CountryIso2))
                            }}
                            renderValue={(value) => (
                                <FlagImage size={24} iso2={value.iso2} style={{ display: 'flex' }} />
                            )}
                        >
                            {defaultCountries.map((c) => {
                                const country = parseCountry(c)
                                return (
                                    <MenuItem key={country.iso2} value={country.iso2}>
                                        <FlagImage
                                            size={16}
                                            iso2={country.iso2}
                                            style={{ marginRight: '8px' }}
                                        />
                                        <Typography marginRight="8px">{country.name}</Typography>
                                        <Typography color="gray">+{country.dialCode}</Typography>
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </InputAdornment>
                )
            }}
            {...restProps}
        />
    )
}
